import { render, staticRenderFns } from "./phyRegisterDialog.vue?vue&type=template&id=bb81e56a&scoped=true"
import script from "./phyRegisterDialog.vue?vue&type=script&lang=js"
export * from "./phyRegisterDialog.vue?vue&type=script&lang=js"
import style0 from "./phyRegisterDialog.vue?vue&type=style&index=0&id=bb81e56a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb81e56a",
  null
  
)

export default component.exports